import { Quote } from "lucide-react";
import Reveal from "./Reveal";

export default function Testimonials({ items, sectionContent }) {
  const eyebrow = sectionContent?.eyebrow || "Depoimentos";
  const headline = sectionContent?.headline || "A confiança de quem buscou refinamento e encontrou estratégia.";

  return (
    <section id="depoimentos" data-testid="testimonials-section" className="bg-softblack text-offwhite py-28 md:py-40 relative grain overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none opacity-40"
        style={{ background: "radial-gradient(60% 60% at 30% 20%, rgba(200,169,126,0.18), transparent 70%)" }}
      />
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <Reveal className="lg:col-span-6">
            <p className="eyebrow !text-champagne/80">{eyebrow}</p>
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-offwhite mt-4 md:mt-6 leading-[1.05]">
              {headline}
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
          {items.map((t, idx) => (
            <Reveal
              key={t.id}
              delay={idx * 120}
              className="relative border-l border-champagne/40 pl-5 md:pl-8"
            >
              <Quote className="text-champagne mb-4 md:mb-6" size={20} strokeWidth={1} />
              <p className="font-serif text-xl sm:text-2xl md:text-[26px] leading-snug text-offwhite italic font-light">
                "{t.quote}"
              </p>
              <div className="mt-6 md:mt-8 pt-4 md:pt-6 border-t border-fendi/20">
                <p className="text-offwhite text-sm tracking-wide font-medium">{t.name}</p>
                {t.role && <p className="eyebrow !text-warmgray mt-1">{t.role}</p>}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
